export const REPAIR_ITEM_OPTIONS = [
  'Left Temple',
  'Right Temple',
  'Bridge',
  'Frame Front',
  'Nosepad Replacement',
  'Nosepad Addition',
] as const;

export type RepairItem = typeof REPAIR_ITEM_OPTIONS[number];
